module.exports = __webpack_public_path__ + "img/00031.de04fd4c.webp";